import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ShieldCheckIcon, ZapIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function HeroSection() {
  return <section className="pt-20 pb-10 md:pt-28 md:pb-16 px-4 bg-cream overflow-hidden" data-id="element-51">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-52">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center text-center space-y-6" data-id="element-53">
          <div className="inline-flex items-center px-3 py-1 rounded-full bg-sage text-primary font-semibold text-sm mb-2" data-id="element-54">
            <StarIcon className="w-4 h-4 mr-1 fill-accent text-accent" data-id="element-55" />
            <span data-id="element-56">El método #1 en nutrición canina</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl text-charcoal leading-[1.15] mb-4 max-w-2xl font-serif font-[700]" data-id="element-57">
            Dale a tu perro lo que{' '}
            <span style={{
            color: '#E8761A'
          }} data-id="element-58">
              realmente necesita
            </span>
          </h1>

          <p className="text-2xl md:text-3xl text-primary italic font-serif leading-relaxed mb-6 max-w-xl tracking-wide font-[600]" data-id="element-59">
            Descubrí cómo hacer el cambio de forma simple y segura — sabiendo
            exactamente qué darle y cuánto
          </p>

          <div className="pt-4 flex flex-col sm:flex-row items-center gap-4" data-id="element-60">
            <CTAButton data-id="element-61" />
          </div>

          {/* Trust Badges */}
          <div className="pt-6 border-t border-gray-200 mt-6 w-full max-w-lg" data-id="element-62">
            <div className="flex items-center justify-center mb-3" data-id="element-63">
              <div className="flex mr-2" data-id="element-64">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-accent text-accent" data-id="element-65" />)}
              </div>
              <span className="font-semibold text-charcoal" data-id="element-66">
                +2.000 dueños satisfechos
              </span>
            </div>
            <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-600 font-medium" data-id="element-67">
              <span className="flex items-center" data-id="element-68">
                <ZapIcon className="w-4 h-4 mr-1 text-accent" data-id="element-69" /> Acceso
                inmediato
              </span>
              <span className="flex items-center" data-id="element-70">
                <ShieldCheckIcon className="w-4 h-4 mr-1 text-primary" data-id="element-71" />{' '}
                Garantía 7 días
              </span>
              <span className="flex items-center" data-id="element-72">
                <LockIcon className="w-4 h-4 mr-1 text-gray-500" data-id="element-73" /> Pago seguro
              </span>
            </div>
          </div>
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative flex justify-center items-center perspective-1000" data-id="element-74">
          {/* Decorative background blob */}
          <div className="absolute inset-0 bg-sage rounded-full blur-3xl opacity-50 transform scale-110" data-id="element-75"></div>

          {/* Ebook Mockup */}
          <motion.div whileHover={{
          scale: 1.02
        }} className="relative z-10 w-full max-w-md flex items-center justify-center transform transition-transform duration-500" style={{
          filter: 'drop-shadow(0 25px 40px rgba(0,0,0,0.2)) drop-shadow(0 10px 15px rgba(0,0,0,0.12))'
        }} data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/juvrdCDTRt1qFbZEHp6o8m/Imagen_ebook_portada_primera.webp" alt="Nutrición Canina Fácil - Ebook + 7 Bonos de Regalo" className="w-full h-auto object-contain" loading="eager" decoding="sync" fetchPriority="high" width={800} height={800} data-id="element-77" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}